module.exports = __webpack_public_path__ + "static/media/Manual_Brand_Set_Up.0ba7c522.png";